import React, { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

export function MachineForm({ machine, categories, saving, error, onClose, onSave }) {
    const [values, setValues] = useState({
        machine: machine?.machine || '',
        category: machine ? String(machine.category) : '',
    });
    const change = field => event => setValues(previous => ({ ...previous, [field]: event.target.value }));
    return (
        <Modal show onHide={saving ? undefined : onClose} backdrop={saving ? 'static' : true} keyboard={!saving} aria-labelledby="machine-form-title">
            <Form onSubmit={event => {
                event.preventDefault();
                onSave({ machine: values.machine.trim(), category: Number(values.category) });
            }}>
                <Modal.Header closeButton={!saving}>
                    <Modal.Title id="machine-form-title">{machine ? 'Edit machine' : 'Add machine'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <fieldset disabled={saving}>
                        <Form.Group controlId="machine-name" className="mb-3">
                            <Form.Label>Machine name</Form.Label>
                            <Form.Control required maxLength={20} pattern=".*\S.*" value={values.machine} onChange={change('machine')} />
                            {machine && <Form.Text>Machines already in use cannot be renamed.</Form.Text>}
                        </Form.Group>
                        <Form.Group controlId="machine-category">
                            <Form.Label>Category</Form.Label>
                            <Form.Select required value={values.category} onChange={change('category')}>
                                <option value="">Select a category</option>
                                {categories.map(category => <option key={category.id} value={String(category.category)}>{category.description}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </fieldset>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={saving} onClick={onClose}>Cancel</Button>
                    <Button type="submit" disabled={saving}>{saving ? 'Saving…' : machine ? 'Save changes' : 'Create machine'}</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
